import { Controller } from "@hotwired/stimulus"

// Parcours de souscription : à chaque réponse modifiée, le formulaire part en mode « live » (bouton
// caché name=live) ; le serveur enregistre la réponse et renvoie le prix en Turbo Stream.
export default class extends Controller {
  static targets = ["live"]

  refresh() {
    this.element.requestSubmit(this.liveTarget)
  }
}
